export const CONSTS = {
  // NOT: name pattern of constant variables: SERVISNAME_REQUESTTYPE_METHOD_NAME

  // Auth Service Constants
  AUTH_POST_LOGIN: 'api/auth/signin',
  AUTH_POST_REGISTER: 'api/auth/signup',
  AUTH_POST_LOGOUT: 'api/auth/signout',

  // Admin Service Constants
  ADMIN_POST_SET_VIRTUAL_COMPANY: 'api/admin/set-virtual-company',

  // User Service Constants
  USER_POST_SET_LANGUAGE: 'api/user/set-language',
  USER_POST_SET_LANDING_PATH: 'api/user/set-landing-path',

  // Dashboard Service Constants
  DASHBOARD_GET_GET_DASHBOARD_COUNTS: 'api/dashboard/counts',
  DASHBOARD_GET_GET_ALL_CAMERAS_DASHBOARD: 'api/dashboard/cameras',
  DASHBOARD_GET_GET_FILTER_EVENTS_BY_ALERT_TYPE_AND_DATE_ALARM_AND_WARNING_COUNT:
    'api/dashboard/filter-by-alert-type',
  DASHBOARD_GET_GET_FILTER_EVENTS_BY_CATEGORY_AND_DATE_MODULE_ALARM_AND_WARNING_CATEGORY_DISTRIBUTION:
    'api/dashboard/filter-by-category',

  // Alert Service Constants
  ALERT_GET_GET_FILTER_EVENTS_BY_ALERT_TYPE_AND_DATE_ALARM_AND_WARNING_LIST:
    'api/event/events',
  ALERT_GET_GET_DAILY_ALARMS_AND_WARNINGS_COUNT_BY_DATES:
    'api/event/get-daily-counts',

  // Entity Count
  ENTITY_COUNT_GET:'api/entity-count/get',
  ENTITY_COUNT_GET_ALL:'api/entity-count/get-all',
  ENTITY_COUNT_GET_DAILY:'api/entity-count/get-daily',

  // Camera Service Constants
  CAMERA_GET_GET_ALL_CAMERAS: 'api/camera/cameras',
  CAMERA_GET_GET_ALL_CAMERAS_WITHOUT_LOCATION:
    'api/camera/get-cameras-without-location',
  CAMERA_GET_GET_CAMERA: 'api/camera/get',
  CAMERA_POST_EDIT_CAMERA: 'api/camera/update',
  CAMERA_POST_DELETE_CAMERA: 'api/camera/delete',

  // Location Service Constants
  LOCATION_GET_GET_ALL_LOCATIONS: 'api/location/locations',
  LOCATION_GET_GET_LOCATION_BY_ID: 'api/location/get',
  LOCATION_POST_ADD_LOCATION: 'api/location/add',
  LOCATION_POST_EDIT_LOCATION: 'api/location/update',
  LOCATION_POST_DELETE_LOCATION: 'api/location/delete',

  // Company Service Constants
  COMPANY_GET_GET_ALL_COMPANIES: 'api/company/companies',
  COMPANY_GET_GET_COMPANY_BY_ID: 'api/company',
  COMPANY_GET_GET_COMPANY_BY_ID2: 'api/company/get',
  COMPANY_POST_ADD_COMPANY: 'api/company/add',
  COMPANY_POST_UPDATE_COMPANY: 'api/company/update',
  COMPANY_POST_DELETE_COMPANY: 'api/company/remove',
  N_POST_DELETE_LOCATION: 'api/location/delete',

  // Face Search Service Constants
  FACESEARCH_GET_GET_ALL_FACESEARCH: 'api/face-search/results',
  FACESEARCH_GET_GET_FACESEARCH: 'api/face-search/result',
  FACESEARCH_POST_SEARCH_FACESEARCH: 'api/face-search/request',
  FACESEARCH_POST_EDIT_FACESEARCH: 'api/face-search/update',
  FACESEARCH_POST_DELETE_FACESEARCH: 'api/face-search/delete',

  // Health Check Service Constants
  HEALTHCHECK_GET_GET_HEALTHSTATUS: 'api/health-check/status',

  // Add Employee Service Constants
  EMPLOYEE_GET_GET_ALL_EMPLOYEES: 'api/employee/employees',
  EMPLOYEE_GET_GET_EMPLOYEE: 'api/employee/get',
  EMPLOYEE_POST_ADD_EMPLOYEE: 'api/employee/add',
  EMPLOYEE_DELETE_DELETE_EMPLOYEE: 'api/employee/delete',
  EMPLOYEE_POST_UPDATE_EMPLOYEE: 'api/employee/update',
  EMPLOYEE_POST_ADD_OR_SET_LOCATION_RELATION: 'api/employee/add-or-set-location-relation',
  EMPLOYEE_POST_REMOVE_LOCATION_RELATION: 'api/employee/remove-location-relation',
  EMPLOYEE_GET_GET_ALL_LOCATION_RELATIONS: 'api/employee/get-all-location-relations',
  EMPLOYEE_GET_GET_EMPLOYEE_SHIFT: 'api/employee/get-employee-shift',
  EMPLOYEE_POST_SET_EMPLOYEE_SHIFT: 'api/employee/update-employee-shift',

  // Add Employee Service Constants
  ZONE_GET_GET_ALL_ZONES: 'api/zone/zones',
  ZONE_GET_GET_ZONE: 'api/zone/get',
  ZONE_POST_ADD_ZONE: 'api/zone/add',
  ZONE_DELETE_DELETE_ZONE: 'api/zone/delete',
  ZONE_POST_UPDATE_ZONE: 'api/zone/update',
  ZONE_GET_GET_ZONE_SHIFT: 'api/zone/get-zone-shift',
  ZONE_POST_SET_ZONE_SHIFT: 'api/zone/update-zone-shift',

  // Add Employee Service Constants
  GENERALANALYSIS_GET_GET_ALL_GENERALANALYSIS: 'api/generalAnalysis/getall',
  GENERALANALYSIS_POST_GENERALANALYSIS: 'api/generalAnalysis/add',

  // Modules Service
  MODULES_GET_GET_ALL_MODULES: 'api/module/modules',

  // Constants Service
  CONSTANTS_GET_GET_ALL_LOCATIONTYPES: 'api/constants/location-types',
  CONSTANTS_GET_GET_ALL_CAMERATYPES: 'api/constants/camera-function-types',
  CONSTANTS_GET_GET_ALL_FIRE_CATEGORIES: 'api/constants/fire-categories',


  CONSTANTS_GET_GET_ALL_FEATURES: 'api/features/get-company-features',


  CONSTANTS_GET_GET_CAMERA_CONNECTION_REPORT: 'api/report/camera-connection',

  SETTINGS_GET_CAMERA_HEALTH_THRESHOLD: 'api/settings/camera-health-threshold/get',
  SETTINGS_SET_CAMERA_HEALTH_THRESHOLD: 'api/settings/camera-health-threshold/update',

  // Settings Service Constants - Break Time
  SETTINGS_BREAK_TIME_LIST: 'api/client-admin/settings/break-time/list',
  SETTINGS_BREAK_TIME_CREATE: 'api/client-admin/settings/break-time/create',
  SETTINGS_BREAK_TIME_UPDATE: 'api/client-admin/settings/break-time/update',
  SETTINGS_BREAK_TIME_DELETE: 'api/client-admin/settings/break-time/delete',

  EVENT_SET_SCAN_SUCCESS: 'api/event/set-scan-success',

  CDN_DOWNLOAD_FILE: 'download',
  CDN_UPLOAD_FILE: 'upload',

  FIRE_FIGHTER_UPDATE_COMPANY: 'api/fire-fighter/update-company',
  FIRE_FIGHTER_UNSET_COMPANY_ON_FIRE: 'api/fire-fighter/unset-company-on-fire',
  FIRE_FIGHTER_GET_ALL_ON_FIRE_COMPANIES: 'api/fire-fighter/get-all-on-fire-companies',
  FIRE_FIGHTER_GET_ALL_COMPANIES: 'api/fire-fighter/get-all-companies',

  FIRE_FIGHTER_GET_ALL_FIRE_FIGHTERS: 'api/fire-fighter/get-all-fire-fighters',
  FIRE_FIGHTER_GET_FIRE_FIGHTER_BASE: 'api/fire-fighter/get-fire-fighter-base',
  FIRE_FIGHTER_EVENT_TRIGGER_SOCKET: 'api/fire-fighter-socket/event-trigger/consume',

  SUPERVISOR_GET_SUPERVISOR: 'api/supervisor/supervisor-company/get',

  // Alert Service Constants
  SUPERVISOR_ALERT_GET_GET_FILTER_EVENTS_BY_ALERT_TYPE_AND_DATE_ALARM_AND_WARNING_LIST:
    'api/supervisor/event/events',
  SUPERVISOR_ALERT_GET_GET_DAILY_ALARMS_AND_WARNINGS_COUNT_BY_DATES:
    'api/supervisor/event/get-daily-counts',
  SUPERVISOR_GET_GET_FILTER_EVENTS_BY_CATEGORY_AND_DATE_MODULE_ALARM_AND_WARNING_CATEGORY_DISTRIBUTION:
    'api/supervisor/event/filter-by-category',
  SUPERVISOR_GET_GET_FILTER_EVENTS_BY_ALERT_TYPE_AND_DATE_ALARM_AND_WARNING_COUNT:
    'api/event/filter-by-alert-type',

  FEATURES_LOGS_GET_ALL: 'api/features/get-company-feature-logs',

};
